// extracted by mini-css-extract-plugin
export default {"root":"breadcrumbs-module--root--Kyhhz","active":"breadcrumbs-module--active--pWhsV"};